import { render, staticRenderFns } from "./FavouritesScreen.vue?vue&type=template&id=f32a0daa&"
import script from "./FavouritesScreen.vue?vue&type=script&lang=ts&"
export * from "./FavouritesScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports